import { render, staticRenderFns } from "./AssetPoolDistribution.vue?vue&type=template&id=1bfabd30&scoped=true&"
import script from "./AssetPoolDistribution.vue?vue&type=script&lang=js&"
export * from "./AssetPoolDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfabd30",
  null
  
)

export default component.exports